import styled from "styled-components";

export const ContentContainer = styled.div`
  padding: 8px;
  display: flex;
  height: 100%;
  // border-bottom: 1px solid lightgrey;
`;

export const Title = styled.div`
  margin-right: auto;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Date = styled.div`
  font-size: 10px;
`;